module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "0px !important"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid #F2F2F2"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "#F9F8F6",
      "border-bottom": "1px solid #F2F2F2",
      "padding-bottom": "20px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "heading-title1"
  }, [_vm._v(_vm._s(_vm.$t('ACCOUNT_INFO_TITLE')))]), _vm._v(" "), _c('br'), _vm._v(_vm._s(_vm.$t('ACCOUNT_INFO_PART_1'))), _c('br'), _vm._v(_vm._s(_vm.$t('ACCOUNT_INFO_PART_2'))), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "heading-title1"
  }, [_vm._v(_vm._s(_vm.$t('ACCOUNT_INFO_PART_5')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "w50",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_vm._m(0), _vm._v("\n                " + _vm._s(_vm.$t('ACCOUNT_INFO_PART_3')) + " "), _c('br'), _vm._v(_vm._s(_vm.$t('ACCOUNT_INFO_PART_4')) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "w50",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_vm._m(1), _vm._v("\n                " + _vm._s(_vm.$t('ACCOUNT_INFO_PART_6')) + "\n                "), _c('ul', {
    staticClass: "ullist",
    staticStyle: {
      "margin-left": "20px"
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.$t('ACCOUNT_INFO_PART_7')))]), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.$t('ACCOUNT_INFO_PART_8')) + " "), _c('br'), _vm._v(_vm._s(_vm.$t('ACCOUNT_INFO_PART_9')))])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "w50",
    staticStyle: {
      "margin": "auto",
      "text-align": "left"
    }
  }, [_vm._m(2), _vm._v(_vm._s(_vm.$t('ACCOUNT_INFO_PART_10'))), _c('br'), _vm._v("\n                " + _vm._s(_vm.$t('ACCOUNT_INFO_PART_11')) + "\n            ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "background": "#F9F8F6",
      "border-bottom": "1px solid #F2F2F2",
      "padding-bottom": "20px"
    }
  }, [_c('br'), _vm._v(" "), _c('span', {
    staticClass: "heading-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('ACCOUNT_INFO_PART_12')))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "40%",
      "margin": "auto",
      "text-align": "left",
      "margin-top": "20px"
    }
  }, [_c('ul', {
    staticClass: "ullist"
  }, [_c('li', [_vm._v("\n                        " + _vm._s(_vm.$t('ACCOUNT_INFO_PART_13')) + "\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(_vm.$t('ACCOUNT_INFO_PART_14')) + "\n                    ")]), _vm._v(" "), _c('li', [_vm._v("\n                        " + _vm._s(_vm.$t('ACCOUNT_INFO_PART_15')) + "\n                    ")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('span', {
    staticClass: "heading-title1"
  }, [_vm._v(" " + _vm._s(_vm.$t('ACCOUNT_INFO_PART_16')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "app-btn app-btn--big app-btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.gotoAccount.apply(null, arguments)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.$t('ACCOUNT_INFO_PART_17')) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "stepOver"
  }, [_c('span', {
    staticClass: "step"
  }, [_vm._v("1")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "stepOver"
  }, [_c('span', {
    staticClass: "step"
  }, [_vm._v("2")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "stepOver"
  }, [_c('span', {
    staticClass: "step"
  }, [_vm._v("3")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e1fcd6a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/auth/account-info.vue
// module id = 1187
// module chunks = 0